import Client from '../infra/http/AxiosClient';
import { constructFormData } from '../components/Utils';

export const login = payload => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await Client.post('accounts/login', payload);
      resolve(response);
    } catch (error) {
      reject(error);
    }
  });
};

export const updateProfile = payload => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await Client.put(
        'accounts/profile',
        constructFormData(payload)
      );
      resolve(response);
    } catch (error) {
      reject(error);
    }
  });
};

export const updateProfileSettings = payload => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await Client.put('accounts/profile/settings', payload);
      resolve(response);
    } catch (error) {
      reject(error);
    }
  });
};

export const changePassword = payload => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await Client.put('accounts/profile/password', payload);
      resolve(response);
    } catch (error) {
      reject(error);
    }
  });
};

export const recoverPassword = payload => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await Client.post('accounts/resetpassword', payload);
      resolve(response);
    } catch (error) {
      reject(error);
    }
  });
};



// WEBPACK FOOTER //
// ./src/services/AuthService.js